import { DeliveryRouteOption } from "./DeliveryRouteOption"

export class DeliveryRoutePlan {
  generatedAt: Date

  deliveriesCount: number

  hasCourierLocation: boolean

  options: DeliveryRouteOption[]

  recommendedOptionKey?: string

  constructor(data: Partial<DeliveryRoutePlan> = {}) {
    this.generatedAt = data.generatedAt ? new Date(data.generatedAt) : new Date()

    this.deliveriesCount = data.deliveriesCount ?? 0

    this.hasCourierLocation = data.hasCourierLocation ?? false

    this.options = (data.options ?? []).map((e) => new DeliveryRouteOption(e))

    this.recommendedOptionKey = data.recommendedOptionKey
  }

  getRecommendedOption(): DeliveryRouteOption | undefined {
    return this.options.find((e) => e.key === this.recommendedOptionKey) ?? this.options[0]
  }
}
